import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuthStore, selectUser } from "@safers/auth";
import { useCurrentSiteId } from "@/hooks/useCurrentSiteId";
import { writeLastArea, writeLastSite } from "@/lib/lastVisit";
import { areaOf } from "@/routes/paths";

export function useRememberVisit(): void {
  const { pathname } = useLocation();
  const siteId = useCurrentSiteId();
  const username = useAuthStore(selectUser)?.username ?? null;
  const area = areaOf(pathname);

  useEffect(() => {
    if (!username || !area) return;
    writeLastArea(username, area);
  }, [username, area]);

  useEffect(() => {
    if (!username || siteId == null) return;
    writeLastSite(username, String(siteId));
  }, [username, siteId]);
}
